module.exports = __webpack_public_path__ + "static/media/mh_logo_green.52f25df3.svg";